import _slicedToArray from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useContext, useState } from 'react';
import { noop, useCreation } from '@features/libs';
import Routes from '@/router';
import { AppRuntimeContext } from '@/App';
import LocationListener from '@/components/location-listener';
import PermissionRoute from '@/components/permission-route';
import { useConnectionState } from '@/hooks/use-connection-state';
import config from '@/constants/config';
import { jsx as _jsx } from "react/jsx-runtime";
var Entry = function Entry() {
  var _useConnectionState = useConnectionState(),
    dispatch = _useConnectionState.dispatch;
  var _useContext = useContext(AppRuntimeContext),
    platformConfig = _useContext.platformConfig;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isTccReady = _useState2[0],
    setIsTccReady = _useState2[1];
  useCreation(function () {
    dispatch.fetchConnectionTccConfig({
      configKeys: [config.ConnectionConfigKey || 'affiliate_connection_submodule_local_config'],
      platformConfig: platformConfig
    }).catch(noop).finally(function () {
      return setIsTccReady(true);
    });
    dispatch.updateState({
      isInAddCreatorToCrmABtest: Boolean(platformConfig === null || platformConfig === void 0 ? void 0 : platformConfig.hasCRMCollectionPermission)
    });
  }, [platformConfig]);
  return isTccReady ? /*#__PURE__*/_jsx(LocationListener, {
    children: /*#__PURE__*/_jsx(PermissionRoute, {
      children: /*#__PURE__*/_jsx(Routes, {})
    })
  }) : null;
};
export default Entry;